import { ToolTipType } from "../types";

export const MAP_SPENDBREAKDOWN_LEGEND: Record<ToolTipType, string> = {
  roi: "ROI",
  spend: "Spend",
  revenue: "Revenue",
};

export const NO_DATA = "N/A";

// 88 days covers 3 months difference in days for the worst case scenario (startDate=Feb)
export const MIN_SIMULATION_DURATION_IN_DAYS = 88;

export const MIN_SIMULATION_DURATION_IN_MONTHS = 3;
export const MAX_SIMULATION_DURATION_IN_MONTHS = 12;
export const LONG_SIMULATION_DURATION_IN_MONTHS = 5;
export const MAX_STARTING_DATE_OFFSET_IN_MONTHS = 10;

export const SHORT_DATE_ERROR_MESSAGE =
  "Scenarios must be at least three months to ensure accuracy. Please select an end date more than three months from the start date.";

export const NAME_ERRORS = {
  REQUIRED: "Scenario Name is required",
  MAX_LENGTH: "Name must be 128 characters or less",
};

export const START_DATE_ERRORS = {
  REQUIRED: "Start Date is required",
  TYPE_ERROR: "Start Date must be a valid date",
};

export const END_DATE_ERRORS = {
  REQUIRED: "End Date is required",
  TYPE_ERROR: "End Date must be a valid date",
};

export const TOTAL_BUDGET_ERRORS = {
  POSITIVE: "Total Budget must be a positive value",
  INTEGER: "Total Budget must be an integer",
  REQUIRED: "Total Budget is required",
  GET_MIN_MAX_MESSAGE: (minimum: string, maximum: string) =>
    `Total Budget must be between ${minimum} and ${maximum}`,
};

export const MEDIA_CONSTRAINT_ERRORS = {
  DUPLICATE:
    "A conflicting constraint already exists for this Funnel Stage/Business Unit/Channel combination.",
};
